// Global storage for selected accessories
window.bsSelectedAccessories = window.bsSelectedAccessories || new Set();

class BsPdpAccModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".bs-pdp-acc-modal",
      openBtn: "[data-open-acc-modal]",
      addBtn: ".bs-pdp-acc-card__add-btn"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("m-sharing__content");
          contentElement.innerHTML = this.modalContent;

          // Get accessory information from the clicked element
          const accElement = e.target.closest('[data-open-acc-modal]');
          const accName = accElement.dataset.accName;
          const accDescription = accElement.dataset.accDescription;
          const accImage = accElement.dataset.accImage;

          // Update modal content with accessory information
          contentElement.querySelector('#bsAccModalTitle').textContent = accName;
          contentElement.querySelector('#bsAccModalDescription').innerHTML = accDescription;

          // Update accessory image
          const imageContainer = contentElement.querySelector('#bsAccModalImage');
          imageContainer.innerHTML = `<img src="${accImage}" alt="${accName}" style="width:100%; height:auto;">`;

          this.modal.appendChild(contentElement);
          this.modal.setSizes("bs-pdp-acc-modal");
          this.modal.open();
        }
      }
    });

    // Handle ADD button clicks
    addEventDelegate({
      selector: this.selectors.addBtn,
      handler: (e) => {
        e.preventDefault();
        e.stopPropagation();

        const card = e.target.closest('.bs-pdp-acc-card');
        const accName = card.querySelector('[data-open-acc-modal]').dataset.accName;
        const accImage = card.querySelector('[data-open-acc-modal]').dataset.accImage;

        // Toggle selection
        if (window.bsSelectedAccessories.has(accName)) {
          window.bsSelectedAccessories.delete(accName);
          e.target.textContent = 'ADD';
          e.target.classList.remove('selected');
        } else {
          window.bsSelectedAccessories.add(accName);
          // Store full accessory data
          if (!window.bsAccessoriesData) {
            window.bsAccessoriesData = {};
          }
          window.bsAccessoriesData[accName] = {
            name: accName,
            image: accImage
          };
          e.target.textContent = 'ADDED';
          e.target.classList.add('selected');
        }
      }
    });
  }
}

customElements.define("bs-pdp-acc-modal", BsPdpAccModal);
